module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp13_6000.b2cfc8d5.png";